import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, effect, inject, input, model, output } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { CheckboxChangeEvent } from 'primeng/checkbox';
import { DocumentiService } from 'src/app/core/documenti.service';
import { DistruzioneAllegato, DistruzioneRequest } from 'src/app/shared/models/DistruzioneRequest.model';

@Component({
  selector: 'app-distruzione-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
  <p-dialog header="Distruzione" [(visible)]="visible" [modal]="true" (onHide)="hideDialog()" [style]="{'width':'460px'}" >
    <label for="numeroNota" class="small-label">Numero Nota/Verbale</label>
    <textarea pInputTextarea id="numeronota" class="text-area-dialog" [rows]="3" [cols]="60" [(ngModel)]="distruzioneRequest.numeroNota"></textarea>
    <label for="dal" class="small-label">Dal</label>
    <p-calendar [showIcon]="true" dateFormat="dd/mm/yy" [selectOtherMonths]="true" appendTo="body" [(ngModel)]="distruzioneRequest.data"
    [inputStyle]="{'width': '187px'}">
    </p-calendar>
    <label for="note" class="small-label">Note</label>
    <textarea pInputTextarea id="note" class="text-area-dialog" [rows]="5" [cols]="60" [(ngModel)]="distruzioneRequest.note" ></textarea>

    @if (allegati(); as all) {
      @if(all.length > 0){
        <p>Selezionare gli allegati da eliminare</p>
      }
    <div class="sez-allegati">
      @for (allegato of all; track $index) {
      <div>
        <div class="grid align-items-start">
          <div class="col-6">
            <p-checkbox [(ngModel)]="checkedArray[$index]" binary="true" class="mr-1" [value]="allegato" [inputId]="allegato.allegatoId"
            (onChange)="change(allegato,$event,$index)"></p-checkbox>
            <label [for]="allegato.allegatoId">{{allegato.fileName}}</label>
          </div>
          <div class="col-6">
          @if (distruzioneRequest.allegati[$index]; as allegatoSelezionato) {
            <div class="flex-column">
              <label>Pagine da eliminare</label>
              <input pInputText type="text"
              placeholder="es. 1 - 5"
              [value]="allegatoSelezionato.pagine"
              (change)="setPagine(allegatoSelezionato,$event)">
            </div>
          }
          </div>
        </div>
      </div>
      }
    </div>
    }

    <p-footer>
      <button pButton type="button" icon="pi pi-times" label="Annulla" (click)="hideDialog()"
        class="p-button-secondary"></button>
      <button pButton type="button" class="p-button-danger" icon="fas fa-fw fa-trash" label="Distruggi" (click)="destroy_click()"
      [disabled]="!distruzioneRequest.data || !distruzioneRequest.numeroNota || (this.allegati().length > 0 && distruzioneRequest.allegati.length == 0)"></button>
    </p-footer>
  </p-dialog>
  `,
  styles: [`
  label { margin-bottom: 4px; margin-top: 20px; color: inherit; }
  label:first-of-type { margin-top: 0; }
  .sez-allegati { justify-content: space-around; margin-top: 11px; }
  .p-field-checkbox{ margin-bottom: 20px}
  .text-area-dialog { min-height: 40px}
  `]
})

export class DistruzioneDialogComponent {
  visible = model.required<boolean>();
  documentId = input<number | undefined>();
  allegati = input<DistruzioneAllegato[]>([]);
  // @Input() isRiproduzione = false;

  hide = output();
  done = output<DistruzioneRequest>();
  fail = output<HttpErrorResponse>();

  public distruzioneRequest: DistruzioneRequest = { data: '', note: '', numeroNota: '', allegati: [] };
  public checkedArray: boolean[] = [];


  private readonly confirmationService = inject(ConfirmationService);
  private readonly documentiService = inject(DocumentiService);

  constructor() {
    effect(() => {
      if (this.visible()) {
        this.checkAllegatiToDelete();
        const allegati = this.allegati() ?? [];
        this.distruzioneRequest = { data: '', note: '', numeroNota: '', allegati: [ ... allegati] };
      }
    });
  }

  hideDialog(): void {
    this.hide.emit();
  }

  setPagine(allegato: DistruzioneAllegato, e: Event): void {
    allegato.pagine = (e.target as HTMLInputElement).value;
  }

  change(allegato: DistruzioneAllegato, e: CheckboxChangeEvent, i: number): void {
    this.checkedArray[i] = e.checked;

    this.distruzioneRequest.allegati = [];
    this.checkedArray.forEach( (v,i) => {
        if (v) {          
          this.distruzioneRequest.allegati[i] = this.allegati()[i];
        }
    });
  }

  destroy_click(): void {
    const documentId = this.documentId();
    if (!documentId || documentId < 0) return;

    // <p>La distruzione del documento è un processo <strong>IRREVERSIBILE</strong> che eliminerà tutti gli allegati e impedirà ogni ulteriore modifica.</p>`,
    this.confirmationService.confirm({
      header: 'Distruzione documento',
      message: `<strong>Distruggere</strong> il documento?
      <p>La distruzione del documento eliminerà anche tutti gli allegati e impedirà ogni ulteriore modifica.</p>`,
      acceptLabel: 'Distruggi',
      icon: 'fas fa-fw fa-trash',
      accept: () => {
        this.distruzioneRequest.allegati = this.distruzioneRequest.allegati.filter(v => v !== null);
        this.documentiService.destroy(documentId, this.distruzioneRequest).subscribe({
          next: () => {
            this.done.emit(this.distruzioneRequest);
            this.hideDialog();
          },
          error: (error: HttpErrorResponse) => {
            this.fail.emit(error);
          }
        });
      }
    });
  }

  private checkAllegatiToDelete(): void {
    this.allegati()?.forEach(e => {
      this.checkedArray.push(true);
    });  
  }
}